export const SET_USER = "AUTH/SET_USER";
export const SET_TOKEN = "AUTH/SET_TOKEN";
export const SET_ROLE = "AUTH/SET_ROLE";
export const SET_GUICHE = "AUTH/SET_GUICHE";
